<template>
  <cTable :fields="fields" :methods="methods" :config="config" :header="header">
  </cTable>
</template>

<script>
import { getFreightRule } from "@/api/finance/freightrule";
import cTable from "@/base/common/index";
export default {
  props: {
    row: {
      type: Object
    }
  },
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: p => {
          p.freightId = this.config.id;
          return getFreightRule(p);
        }
      },
      config: {
        id: this.row.quotation_id,
        slot: "div",
        custom: false
      },
      modals: {},
      header: {
        searchs: [],
        config: {
          custom: false
        }
      },
      fields: [
        // {
        //   type: "checkbox",
        //   width: 60
        // },
        {
          name: () => this.$t("min_weight"),
          key: "first_weight",
					minWidth: 130
        },
        {
          name: () => this.$t("max_weight"),
          key: "additional_weight",
					minWidth: 130
        },
        {
          name: () => this.$t("begin_price"),
          key: "first_weight_price",
					minWidth: 130
        },
        {
          name: () => this.$t("step_price"),
          key: "additional_weight_price",
					minWidth: 130
        },
        {
          name: () => this.$t("lower_threshold"),
          key: "lower_threshold",
					minWidth: 130
        },
        {
          name: () => this.$t("upper_threshold"),
          key: "upper_threshold",
					minWidth: 130
        },
				{
				  name: () => this.$t("discount"),
				  key: "discount",
				  minWidth: 130
				},
				{
				  name: () =>
				    this.$t("discount") + this.$t("after") + this.$t("begin_price"),
				  key: "after_first_weight_price",
				  minWidth: 130
				},
				{
				  name: () =>
				    this.$t("discount") + this.$t("after") + this.$t("step_price"),
				  key: "after_additional_weight_price",
				  minWidth: 130
				},
				{
				  name: () => this.$t("FreightVATRadio"),
				  key: "fee_vat_scale",
				  width: 120,
					methods:{
						render({value}){
							return value + '%'
						}
					}
				},
        {
          name: () => this.$t("extra_charge"),
          key: "extra_charge",
					minWidth: 130
        },
        {
          name: () => this.$t("is_calculate"),
          key: "is_calculate",
          width: 130,
          render: (h, { row }) => {
            return h("span", row.is_calculate == 1 ? "YES" : "NO");
          }
        },
        {
          name: () => this.$t("fixed_fee"),
          key: "fixed_fee",
					minWidth: 130
        },
        {
          name: () => this.$t("start") + this.$t("time"),
          key: "start_time",
          width: 150
        },
        {
          name: () => this.$t("end") + this.$t("time"),
          key: "end_time",
          width: 150
        }
      ]
    };
  }
};
</script>
